module.exports = {"370402001":"中心街街道","370402002":"各塔埠街道","370402003":"矿区街道","370402004":"文化路街道办事","370402005":"龙山路街道","370402006":"光明路街道办事","370402101":"税郭镇","370402102":"孟庄镇","370402103":"齐村镇","370402104":"永安镇","370402105":"西王庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370402.json
// module id = 1278
// module chunks = 0